module.exports = __webpack_public_path__ + "static/media/pdf.4e09a5af.svg";